const strings = {
  en: {
    sectionLabel: 'Legal',
    title: 'Account Deletion Request',
    subtitle: 'How to request deletion of your SAPOT AI account and associated data.',
    s1Title: '1. App and Developer',
    s1p1: 'This page applies to the SAPOT AI mobile application published by Dataverse Sdn Bhd.',
    s2Title: '2. How to Request Account Deletion',
    s2p1: 'To request account deletion, send an email to noreply@mampuai.com using the subject line "Delete My SAPOT AI Account".',
    s2l1: [
      'Your registered email address or phone number',
      'Your company name (if applicable)',
      'A short confirmation that you want to permanently delete your account',
    ],
    s2p2: 'Our support team may contact you to verify account ownership before processing the deletion.',
    s3Title: '3. What Data Will Be Deleted',
    s3p1: 'After successful verification, we will delete or anonymize data associated with your account, including:',
    s3l1: [
      'Profile and account details',
      'Conversation records and interaction logs linked to your account',
      'App usage data tied to your personal account identity',
    ],
    s4Title: '4. What Data May Be Retained',
    s4p1: 'We may retain limited data when required for legal, security, fraud prevention, billing, or regulatory compliance purposes.',
    s4l1: [
      'Transaction or invoice records required by applicable law',
      'Security logs used for abuse prevention and incident investigation',
      'Backup copies retained for disaster recovery for a limited period',
    ],
    s5Title: '5. Retention Period',
    s5p1: 'Most account data is deleted within 30 days after verification. Certain legal/compliance records may be retained for up to 180 days, or longer if required by law.',
    s6Title: '6. Deleting Data Without Deleting Account',
    s6p1: 'If you want to delete specific data but keep your account active, contact us at the same email and describe the data you want removed.',
    s7Title: '7. Contact',
    s7p1: 'For account deletion requests and privacy support, contact:',
    contactEmail: 'noreply@mampuai.com',
    contactAddress: '63-4B, Tingkat 4, Jalan Anggerik Vanilla T 31/T, Kota Kemuning, 40460 Shah Alam, Selangor',
  },
  zh: {
    sectionLabel: 'Legal',
    title: 'Account Deletion Request',
    subtitle: 'How to request deletion of your SAPOT AI account and associated data.',
    s1Title: '1. App and Developer',
    s1p1: 'This page applies to the SAPOT AI mobile application published by Dataverse Sdn Bhd.',
    s2Title: '2. How to Request Account Deletion',
    s2p1: 'To request account deletion, send an email to noreply@mampuai.com using the subject line "Delete My SAPOT AI Account".',
    s2l1: [
      'Your registered email address or phone number',
      'Your company name (if applicable)',
      'A short confirmation that you want to permanently delete your account',
    ],
    s2p2: 'Our support team may contact you to verify account ownership before processing the deletion.',
    s3Title: '3. What Data Will Be Deleted',
    s3p1: 'After successful verification, we will delete or anonymize data associated with your account, including:',
    s3l1: [
      'Profile and account details',
      'Conversation records and interaction logs linked to your account',
      'App usage data tied to your personal account identity',
    ],
    s4Title: '4. What Data May Be Retained',
    s4p1: 'We may retain limited data when required for legal, security, fraud prevention, billing, or regulatory compliance purposes.',
    s4l1: [
      'Transaction or invoice records required by applicable law',
      'Security logs used for abuse prevention and incident investigation',
      'Backup copies retained for disaster recovery for a limited period',
    ],
    s5Title: '5. Retention Period',
    s5p1: 'Most account data is deleted within 30 days after verification. Certain legal/compliance records may be retained for up to 180 days, or longer if required by law.',
    s6Title: '6. Deleting Data Without Deleting Account',
    s6p1: 'If you want to delete specific data but keep your account active, contact us at the same email and describe the data you want removed.',
    s7Title: '7. Contact',
    s7p1: 'For account deletion requests and privacy support, contact:',
    contactEmail: 'noreply@mampuai.com',
    contactAddress: '63-4B, Tingkat 4, Jalan Anggerik Vanilla T 31/T, Kota Kemuning, 40460 Shah Alam, Selangor',
  },
};

export default strings;
